"use strict";

exports.__esModule = true;
exports.bytes = void 0;
var _domain = require("../domain");
const bytes = {
  types: ['google.protobuf.BytesValue', 'BYTES'],
  [_domain.ConverterType.TO_JSON]: {
    transform: val => {
      const chars = val.reduce((res, c) => res + String.fromCharCode(c), '');
      return btoa(chars);
    }
  },
  [_domain.ConverterType.FROM_JSON]: {
    transform: val => {
      return Uint8Array.from(atob(val), c => c.charCodeAt(0));
    }
  }
};
exports.bytes = bytes;
//# sourceMappingURL=bytes.js.map